export default {
  satisfactionMessageModalFeedback: 'Thanks for your feedback!',
  submitSatisfactionFormAriaLabel: 'Submit Satisfaction Form',
  submitSatisfactionSubmitButton: 'Submit',
};
